import type { UserProfile } from "adl-gen/ferovinum/app/api";

export function isAdmin(user: UserProfile): boolean {
  return user.adminRole === "admin" || user.adminRole === "superAdmin";
}
